<template>
  <div class="tmz-search">
    <div class="container">
      <h1 class="tmz-search__title">Поиск ВЛ и НВЛ товарно-материальных запасов группы компаний АО НК «КазМунайГаз»</h1>
      <form v-on:keyup.enter="search()" v-on:submit.prevent>
        <div class="tmz-search__header">
        <model-select
            class="tmz-search__header__input"
						:options="categories"
						v-model="category"
						placeholder="Категория"
            ref="searchCategoryInput"
					></model-select>
        <input class="tmz-search__header__input" type="text" v-model="codeTmc" placeholder="Введите код">
        <input class="tmz-search__header__input" type="text" v-model="nameTmc" placeholder="Введите наименование">
        <input class="tmz-search__header__input" type="text" v-model="codeEnstru" placeholder="Код ENSTRU">
        <button
          class="transition-all ease-in-out duration-150 transform hover:scale-110 bg-blue-500 hover:bg-blue-600 px-10 rounded-lg text-white"
          @click="search()">
          Поиск
        </button>
        <button
          class="transition-all ease-in-out duration-150 transform hover:scale-110 bg-blue-500 hover:bg-blue-600 px-10 rounded-lg text-white"
          @click="clearFilters()">
          Сбросить
        </button>
        <button
          class="transition-all ease-in-out duration-150 transform hover:scale-110 bg-blue-500 hover:bg-blue-600 px-10 rounded-lg text-white"
          @click="download()">
          Скачать
        </button>
        </div>
      </form>
      <div class="tmz-search__content">
        <table class="tmz-search__content__table">
					<thead>
						<tr>
							<th>№ п/п</th>
							<th>Наименование ДЗО</th>
							<th>Администратор (структурное подразделение)</th>
							<th>Группа товаров</th>
							<th>Код ТМЦ (согласно учетной системе)</th>
							<th>Полное наименование ТМЦ</th>
							<th> Ед. изм.</th>
							<th>Объем остатков</th>
							<th>Дата поступления</th>
							<th>Категория НВЛ/НЛ</th>
						</tr>
					</thead>
					<tbody>
						<tr
							v-for="(item, index) in results"
							:key="item.id"
						>
							<td>{{ defineIndex(index) }}</td>
							<td>{{ item.tmz_dzo_name }}</td>
              <td>{{ item.abp }}</td>
              <td>{{ item.category }}</td>
              <td>{{ item.code_tmc ? item.code_tmc : 'Отсутствует' }}</td>
              <td>{{ item.name_tmc }}</td>
              <td>{{ item.measure_unit }}</td>
              <td>{{ item.remains_after_tmz_count }}</td>
              <td>{{ item.remains_before_tmz_delivery_date | formatDateTwo }}</td>
              <td>{{ item.type }}</td>
						</tr>
					</tbody>
				</table>
      </div>
      <div class="tmz-search__pagination">
        <pagination v-if="this.pageCount > 1" :currentPage="this.page" :pageCount="this.pageCount" @pageClicked="search" />
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import store from '../store';
import NProgress from 'nprogress';
import Pagination from '../components/shared/Pagination.vue';
import { ModelSelect } from 'vue-search-select';
  export default {
    components: {
      Pagination,
      ModelSelect
    },
    data() {
      return {
        category: '',
        codeTmc: '',
        nameTmc: '',
        codeEnstru: '',
        page: 1,
        results: [],
        categories: []
      }
    },
    computed: {
      pageCount() {
        return this.$store.state.tmz.tmzSearchPageCount
      }
    },
    mounted () {
      this.getCategories()
    },
    methods: {
      defineIndex(index) {
        if (this.page == 1) {
          return index + 1
        } else {
          if (index == 9) {
            return `${this.page}0`
          } else {
            return `${this.page - 1}${index + 1}`
          }
        }
      },
      getCategories() {
        axios.get('tmz/vl-nvl-categories/').then((response) => {
          this.categories = response.data
        })
      },
      search (page = 1) {
        NProgress.start();
        let payload = {
          page: page,
          category: this.category,
          code_tmc: this.codeTmc,
          name_tmc: this.nameTmc,
          ens_tru: this.codeEnstru
        }
        this.page = page
        store.dispatch('searchTmzKmg', payload)
          .then(response => {
            this.results = response.results
            NProgress.done();
          })
          .catch(error => {
            NProgress.done();
            store.dispatch('addNotification', {
              type: 'error',
              message: error?.response?.data || 'Ошибка при поиске',
            })
          })
      },
      clearFilters () {
        this.category = ''
        this.codeTmc = ''
        this.nameTmc = ''
        this.codeEnstru = ''
      },
      download () {
        let payload = {
          category: this.category,
          code_tmc: this.codeTmc,
          name_tmc: this.nameTmc,
          ens_tru: this.codeEnstru
        }

        axios
				.get('/tmz/download_searched_kmg_excel/', {
					params: payload,
					responseType: 'blob',
				}).then((response) => {
					const url = URL.createObjectURL(
							new Blob([response.data], {
								type: 'application/vnd.ms-excel',
							})
						)
						const link = document.createElement('a')
						link.href = url
						link.setAttribute('download', 'Поисковая форма.xlsx')
						document.body.appendChild(link)
						link.click()
				})
      }
    }
  }
</script>

<style scoped>
.tmz-search {
  padding-top: 2rem;
}

.tmz-search__title {
  text-align: center;
  margin: 1rem 0 1.5rem;
  font-weight: 700;
  font-size: 24px;
  line-height: 28px;
}

.tmz-search__header {
  display: flex;
  gap: 1rem;
  justify-content: center;
}

.tmz-search__header__input {
  widows: 100%;
  min-width: 250px;
  max-width: 300px;
  border: 1px solid #D6D6D8;
  padding: .5rem;
  border-radius: 8px;
}

.tmz-search__header__input:focus {
  border: 1px solid #2563ebd9;
}

.tmz-search__content {
  display: flex;
  justify-content: center;
  padding-top: 2rem;
}

.tmz-search__pagination {
  padding: 2rem 0;
}

.tmz-search__content__table {
}

table {
	border-collapse: collapse;
	width: 100%;
	max-width: 1460px;
	padding: 1rem;
}

thead {
	background: #f3f5ff;
	height: 70px;
}

thead th:nth-child(1) {
	border-top-left-radius: 10px;
}

thead th:last-child {
	border-top-right-radius: 10px;
}

th {
	padding: 1rem;
	color: #565656;
}

tr {
	cursor: pointer;
}

tr:hover {
	background: #f3f5ff;
}

td {
	padding: 1rem;
	text-align: center;
	border: 1px solid #e3e3e3;
}
</style>
